// VariationCodeTask.js
// Wariacje z powtórzeniami — k-znakowy kod z n cyfr (wynika z kontekstu „kodu”)

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// Pomocniczo: wybierz losowo n różnych cyfr z {0,...,9} i posortuj rosnąco
function pickDistinctDigits(n) {
  const pool = Array.from({ length: 10 }, (_, d) => d);
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool.slice(0, n).sort((a, b) => a - b);
}

export function generateTask() {
  const k = Math.floor(Math.random() * 3) + 4; // 4..6
  const n = Math.floor(Math.random() * 8) + 3; // 3..10
  const digits = pickDistinctDigits(n);        // np. [0,2,5,7,...]
  const answer = Math.pow(n, k);               // n^k

  return {
    type: "VariationCodeTask",
    data: { k, n, digits, answer },
  };
}

export function renderTask({ data }) {
  const { k, digits } = data;
  const digitsSetLatex = `\\{${digits.join(",\\,")}\\}`;
  return (
    <div style={{ textAlign: "left" }}>
      <p>
        Tworzymy kod złożony z <InlineMath math={`${k}`} /> znaków.
        Każdy znak wybieramy spośród cyfr:
      </p>
      <p><InlineMath math={digitsSetLatex} /></p>
      <p>Na ile różnych sposobów można utworzyć taki kod?</p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label=""
      placeholder="Wpisz liczbę kodów"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") {
    return { correct: false, message: "Podaj liczbę." };
  }
  const given = parseInt(userAnswer.raw, 10);
  if (Number.isNaN(given)) {
    return { correct: false, message: "Podaj liczbę całkowitą." };
  }
  const correct = given === data.answer;
  userAnswer.correctAnswer = data.answer;
  return { correct, message: correct ? "Dobrze!" : "Spróbuj ponownie." };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`${data.answer}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`${userAnswer.raw}`} />;
}

export function renderExplanation({ data }) {
  const { n, k, answer } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1. Dedukcja i wzór.</strong> Mamy kod długości{" "}
        <InlineMath math={`${k}`} />, a na każdą pozycję wybieramy jedną z{" "}
        <InlineMath math={`${n}`} /> cyfr. Zatem liczbę kodów opisuje wzór
        (wariacje z powtórzeniami):
      </p>
      <BlockMath math={`V'(n,k)=n^k`} />

      <p>
        <strong>Krok 2. Podstawienie i obliczenie.</strong>
      </p>
      <BlockMath math={`${n}^{${k}} = ${answer}`} />
    </div>
  );
}
